/**
 * Cart badge + post–add-to-cart UI (theme drawer / apps).
 *
 * Optional: window.__WYDE_CART_CONFIG__ = {
 *   skipThemeDrawer: true,
 *   openCartSelectors: ['#selector'],
 *   extraEvents: ['custom:event'],
 *   onCartAdd: function () {}
 * };
 */
(function () {
  if (window.__WYDE_CART_COUNT_UPDATER_PATCHED__) return;
  window.__WYDE_CART_COUNT_UPDATER_PATCHED__ = true;

  var CART_MUTATION_PATTERNS = [
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear'
  ];

  var SETTLE_MS = 450;
  var DRAWER_FALLBACK_MS = 550;
  var APP_SIGNAL_DELAY_MS = 120;

  var refreshTimer = null;
  var inFlightMutations = 0;
  var postAddTimer = null;
  var postAddFollowUpTimer = null;
  /** Bumps when user does cart/change|update|clear so stale post-add timers never open the drawer. */
  var postAddUiGeneration = 0;
  /** If quantity (or any non-add cart POST) runs after an add started but before it finishes, skip opening the drawer for that add. */
  var lastNonAddCartMutationMs = 0;

  function cancelPendingPostAddDrawerUi() {
    postAddUiGeneration += 1;
    if (postAddTimer) {
      clearTimeout(postAddTimer);
      postAddTimer = null;
    }
    if (postAddFollowUpTimer) {
      clearTimeout(postAddFollowUpTimer);
      postAddFollowUpTimer = null;
    }
  }

  /**
   * True browser fetch — set in theme.liquid <head> before any app touches fetch.
   */
  var originFetch =
    typeof window.__WYDE_ORIGIN_FETCH__ === 'function'
      ? window.__WYDE_ORIGIN_FETCH__
      : window.fetch.bind(window);

  /**
   * Chain at load time (Klaviyo etc. may already wrap fetch). We become the outer wrapper.
   */
  var innerFetch =
    typeof window.fetch === 'function' ? window.fetch.bind(window) : originFetch;

  function getPathname(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (_) {
      return String(url);
    }
  }

  function isCartMutation(url, method) {
    if (method && String(method).toUpperCase() !== 'POST') return false;
    var p = getPathname(url);
    return CART_MUTATION_PATTERNS.some(function (pat) {
      return p.indexOf(pat) !== -1;
    });
  }

  function isCartAdd(url, method) {
    if (method && String(method).toUpperCase() !== 'POST') return false;
    return getPathname(url).indexOf('/cart/add') !== -1;
  }

  function formActionIsCartAdd(form) {
    if (!form || !form.action) return false;
    var a = String(form.action);
    return a.indexOf('/cart/add') !== -1 || a.indexOf('cart/add') !== -1;
  }

  // ── Badge (always uses originFetch — never our wrapper) ───────────────────

  function updateBadges(count) {
    document.querySelectorAll('cart-count, #CartCount').forEach(function (el) {
      if (count > 0) {
        el.innerHTML =
          '<div class="cart-count' + (count > 9 ? ' cart-count--ellipse' : '') + '">' +
            '<span aria-hidden="true">' + count + '</span>' +
          '</div>';
      } else {
        el.innerHTML = '';
      }
    });
  }

  function fetchAndUpdateBadge() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    originFetch(root + 'cart.js?t=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadges(cart.item_count); })
      .catch(function () {});
  }

  function scheduleBadgeRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      if (inFlightMutations > 0) {
        scheduleBadgeRefresh();
        return;
      }
      fetchAndUpdateBadge();
    }, SETTLE_MS);
  }

  function getCartConfig() {
    return window.__WYDE_CART_CONFIG__ || {};
  }

  function getUpcartBridge() {
    return window.__WYDE_UPCART__ || null;
  }

  function isUpcartActive() {
    var bridge = getUpcartBridge();
    return !!(bridge && typeof bridge.isActive === 'function' && bridge.isActive());
  }

  function isUpcartDrawerOpen() {
    var bridge = getUpcartBridge();
    if (bridge && typeof bridge.isDrawerOpen === 'function') {
      try {
        return bridge.isDrawerOpen();
      } catch (_) {}
    }
    return false;
  }

  function isThemeCartSuppressed() {
    if (getCartConfig().skipThemeDrawer) return true;
    try {
      return document.documentElement.hasAttribute('data-wyde-theme-cart-disabled');
    } catch (_) {
      return false;
    }
  }

  function tryOpenUpcartWithRetry() {
    if (tryOpenUpcartOnce()) return;
    var tries = 0;
    var retry = setInterval(function () {
      tries += 1;
      if (tryOpenUpcartOnce() || tries >= 24) clearInterval(retry);
    }, 150);
  }

  function suppressLegacyThemeCartDrawer() {
    var bridge = getUpcartBridge();
    if (bridge && typeof bridge.suppressThemeCartDrawer === 'function') {
      try {
        bridge.suppressThemeCartDrawer();
      } catch (_) {}
    }
  }

  function tryOpenUpcartOnce() {
    var bridge = getUpcartBridge();
    if (bridge && typeof bridge.openCart === 'function') {
      try {
        return bridge.openCart();
      } catch (_) {}
    }
    if (typeof window.upcartOpenCart === 'function') {
      try {
        window.upcartOpenCart();
        return true;
      } catch (_) {}
    }
    if (window.UpCart && typeof window.UpCart.open === 'function') {
      try {
        window.UpCart.open();
        return true;
      } catch (_) {}
    }
    return false;
  }

  function notifyUpcartCartChange() {
    var bridge = getUpcartBridge();
    if (bridge && typeof bridge.notifyCartChange === 'function') {
      try {
        bridge.notifyCartChange();
      } catch (_) {}
    }
    if (bridge && typeof bridge.scrubZeroBadges === 'function') {
      try {
        bridge.scrubZeroBadges();
      } catch (_) {}
    }
  }

  function broadcastCartSignalsForApps() {
    var cfg = getCartConfig();
    var names = [
      'cart:updated',
      'cart:refresh',
      'cart:open',
      'ajaxCart:updated',
      'ajaxProduct:added',
      'drawer:cart:open',
      'shopify:cart:change',
      'amp:cart:updated',
      'wyde:upcart:cart-change'
    ];
    if (cfg.extraEvents && cfg.extraEvents.length) {
      names = names.concat(cfg.extraEvents);
    }
    var opts = { bubbles: true, cancelable: true };
    names.forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, opts));
        window.dispatchEvent(new CustomEvent(name, opts));
      } catch (_) {}
    });
    if (window.jQuery) {
      try {
        window.jQuery(document).trigger('cart:open');
        window.jQuery(document).trigger('ajaxCart:updated');
        window.jQuery(document).trigger('ajaxProduct:added');
      } catch (_) {}
    }
    if (typeof cfg.onCartAdd === 'function') {
      try {
        cfg.onCartAdd();
      } catch (_) {}
    }
  }

  function clickIfVisible(el) {
    if (!el || typeof el.click !== 'function') return;
    try {
      el.click();
    } catch (_) {}
  }

  /** Theme cart icon + common app hooks (Safari: real .click() on header button). */
  function tryClickCartTriggers() {
    if (isAnyCartDrawerUiOpen()) return;
    if (isThemeCartSuppressed() || isUpcartActive()) {
      suppressLegacyThemeCartDrawer();
      tryOpenUpcartWithRetry();
      return;
    }
    var cfg = getCartConfig();
    var list = cfg.openCartSelectors || cfg.openCartClickSelectors;
    if (!list || !list.length) {
      list = [
        '[data-sidebar-button][data-sidebar-id="CartDrawer"]',
        'sidebar-button [data-sidebar-button][data-sidebar-id="CartDrawer"]',
        'sticky-cart-button [data-sidebar-button][data-sidebar-id="CartDrawer"]',
        'header-component [data-sidebar-button][data-sidebar-id="CartDrawer"]',
        '[data-cart-drawer-toggle]',
        '[data-drawer-toggle="cart"]',
        '[data-sticky-cart-open]',
        'button[name="open-cart"]',
        '.js-drawer-open-cart'
      ];
    }
    list.forEach(function (sel) {
      if (!sel || typeof sel !== 'string') return;
      try {
        var el = document.querySelector(sel);
        clickIfVisible(el);
      } catch (_) {}
    });
  }

  function isThemeDrawerOpen() {
    if (isThemeCartSuppressed()) return false;
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!d) return false;
    return d.classList.contains('is-opened') || d.getAttribute('open') !== null;
  }

  /** Theme sidebar cart, UpCart shadow drawer, or AMP / AfterSell `#amp-theme-extension`. */
  function isAnyCartDrawerUiOpen() {
    if (isThemeDrawerOpen()) return true;
    if (isUpcartDrawerOpen()) return true;
    var ext = document.getElementById('amp-theme-extension');
    if (!ext || !ext.isConnected) return false;
    if (ext.getAttribute('hidden') != null && String(ext.getAttribute('hidden')) !== 'false') return false;
    if (ext.getAttribute('aria-hidden') === 'true') return false;
    try {
      var st = window.getComputedStyle(ext);
      if (st.display === 'none' || st.visibility === 'hidden') return false;
      /** Treat as open if drawer shell exists — avoids false negatives while AMP re-renders line items (Wyde scroll host / React). */
      if (ext.querySelector('.amp-cart-drawer--scrollable, .amp-cart-drawer__inner')) return true;
      if (!ext.querySelector('.amp-cart')) return false;
      return true;
    } catch (e2) {
      return false;
    }
  }

  function tryOpenThemeDrawerOnce() {
    if (isThemeCartSuppressed()) {
      suppressLegacyThemeCartDrawer();
      if (!isAnyCartDrawerUiOpen()) tryOpenUpcartWithRetry();
      return;
    }
    if (isUpcartActive()) {
      if (!isAnyCartDrawerUiOpen()) tryOpenUpcartOnce();
      return;
    }
    if (isAnyCartDrawerUiOpen()) return;
    var d = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!d || isThemeDrawerOpen()) return;
    if (typeof d.open === 'function') {
      try {
        d.open();
      } catch (_) {}
    }
  }

  /** Runs after a successful add (fetch) or delayed after form submit (Safari / missed fetch). */
  function schedulePostAddDrawerUi() {
    cancelPendingPostAddDrawerUi();
    var gen = postAddUiGeneration;
    broadcastCartSignalsForApps();
    setTimeout(function () {
      if (gen !== postAddUiGeneration) return;
      broadcastCartSignalsForApps();
    }, APP_SIGNAL_DELAY_MS);

    postAddTimer = setTimeout(function () {
      postAddTimer = null;
      if (gen !== postAddUiGeneration) return;
      broadcastCartSignalsForApps();
      suppressLegacyThemeCartDrawer();
      tryClickCartTriggers();
      tryOpenThemeDrawerOnce();
      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('cart-drawer').then(function () {
          if (gen !== postAddUiGeneration) return;
          tryOpenThemeDrawerOnce();
          tryClickCartTriggers();
        }).catch(function () {});
      }
    }, DRAWER_FALLBACK_MS);

    postAddFollowUpTimer = setTimeout(function () {
      postAddFollowUpTimer = null;
      if (gen !== postAddUiGeneration) return;
      if (isAnyCartDrawerUiOpen()) return;
      tryClickCartTriggers();
      tryOpenThemeDrawerOnce();
    }, DRAWER_FALLBACK_MS + 450);
  }

  /**
   * Safari / third-party: if window.fetch was replaced after our patch, we never see the add.
   * Do not run immediately (add is still in flight) — retry opening after typical AJAX latency.
   */
  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (!formActionIsCartAdd(form)) return;
      var g = postAddUiGeneration;
      [700, 1400].forEach(function (ms) {
        setTimeout(function () {
          if (g !== postAddUiGeneration) return;
          if (isAnyCartDrawerUiOpen()) return;
          broadcastCartSignalsForApps();
          tryClickCartTriggers();
          tryOpenThemeDrawerOnce();
        }, ms);
      });
    },
    true
  );

  function wydeFetch() {
    var args = arguments;
    var url = typeof args[0] === 'string'
      ? args[0]
      : (args[0] && args[0].url ? args[0].url : '');
    var method = (args[1] && args[1].method)
      ? args[1].method
      : (args[0] instanceof Request ? args[0].method : 'GET');

    var promise = innerFetch.apply(this, args);

    if (!isCartMutation(url, method)) {
      return promise;
    }

    inFlightMutations += 1;
    var addMutation = isCartAdd(url, method);
    var addStartedMs = addMutation ? Date.now() : null;
    if (!addMutation) {
      lastNonAddCartMutationMs = Date.now();
      cancelPendingPostAddDrawerUi();
    }

    promise.then(
      function (res) {
        if (res && res.ok) {
          notifyUpcartCartChange();
        }
        if (res && res.ok && addMutation) {
          if (lastNonAddCartMutationMs > addStartedMs) {
            return;
          }
          schedulePostAddDrawerUi();
        } else if (res && res.ok && !addMutation) {
          lastNonAddCartMutationMs = Date.now();
          cancelPendingPostAddDrawerUi();
        }
      },
      function () {}
    );

    if (typeof promise.finally === 'function') {
      promise.finally(function () {
        inFlightMutations = Math.max(0, inFlightMutations - 1);
        scheduleBadgeRefresh();
      });
    } else {
      promise.then(
        function () {
          inFlightMutations = Math.max(0, inFlightMutations - 1);
          scheduleBadgeRefresh();
        },
        function () {
          inFlightMutations = Math.max(0, inFlightMutations - 1);
          scheduleBadgeRefresh();
        }
      );
    }

    return promise;
  }

  window.fetch = wydeFetch;

  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._wydeUrl = url;
    this._wydeMethod = method;
    return _xhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isCartMutation(xhr._wydeUrl, xhr._wydeMethod)) {
      inFlightMutations += 1;
      var finished = false;
      var isAdd = isCartAdd(xhr._wydeUrl, xhr._wydeMethod);
      var addStartedMs = isAdd ? Date.now() : null;
      if (!isAdd) {
        lastNonAddCartMutationMs = Date.now();
        cancelPendingPostAddDrawerUi();
      }
      function end() {
        if (finished) return;
        finished = true;
        inFlightMutations = Math.max(0, inFlightMutations - 1);
        scheduleBadgeRefresh();
        if (xhr.status >= 200 && xhr.status < 300) {
          notifyUpcartCartChange();
        }
        if (isAdd && xhr.status >= 200 && xhr.status < 300) {
          if (lastNonAddCartMutationMs > addStartedMs) {
            return;
          }
          schedulePostAddDrawerUi();
        } else if (!isAdd && xhr.status >= 200 && xhr.status < 300) {
          lastNonAddCartMutationMs = Date.now();
          cancelPendingPostAddDrawerUi();
        }
      }
      xhr.addEventListener('load', end);
      xhr.addEventListener('error', end);
      xhr.addEventListener('abort', end);
      xhr.addEventListener('timeout', end);
    }
    return _xhrSend.apply(this, arguments);
  };
})();
